import {
  BookOpenCheckIcon,
  ExternalLinkIcon,
  KeyboardIcon,
  PlaySquareIcon,
  PointerIcon,
  SendHorizonalIcon,
  UsersIcon,
} from "lucide-react";
import { memo, useState } from "react";
import { useCreateTutuorialCanvas } from "@/hooks/useCreateTutuorialCanvas";
import { openSupportEmail } from "@/utils/support";
import { useCanvasId } from "@/utils/utils";
import { Button } from "../ui/button";
import KeyboardShortcutsModal from "./KeyboardShortcutsModal";

type Props = {};

const InfoPanel = memo((props: Props) => {
  const canvasId = useCanvasId();
  const [isShortcutsModalOpen, setIsShortcutsModalOpen] = useState(false);

  const getHelpInfo = () => {
    // Check if we're on a project page
    const urlParams = new URLSearchParams(window.location.search);
    const projectId = urlParams.get("project_id");

    // Default to canvas link if available
    if (canvasId) {
      return `Help Info: My canvas link is ${window.location.origin}/canvases/${canvasId}/editor\n\nMessage: `;
    }

    if (projectId) {
      return `Help Info: My project page link is ${window.location.origin}/?project_id=${projectId}\n\nMessage: `;
    }

    // If neither, just return the current URL
    return `Help Info: My page link is ${window.location.href}\n\nMessage: `;
  };

  const createTutorialCanvas = useCreateTutuorialCanvas();

  const links = [
    {
      icon: BookOpenCheckIcon,
      title: "Docs",
      href: "https://tempolabsinc.mintlify.app",
    },
    {
      icon: PlaySquareIcon,
      title: "Tutorial Videos",
      href: "https://www.youtube.com/watch?v=CaiKr-TONLY",
    },
    {
      icon: PointerIcon,
      title: "Tutorial Playground",
      onClick: () => {
        createTutorialCanvas();
      },
    },
    {
      icon: UsersIcon,
      title: "Community",
      href: "https://discord.gg/Arp8FZuBrs",
    },
    {
      icon: SendHorizonalIcon,
      title: "Contact Us",
      onClick: () => {
        openSupportEmail(getHelpInfo());
      },
    },
    {
      icon: KeyboardIcon,
      title: "Keyboard Shortcuts",
      onClick: () => {
        setIsShortcutsModalOpen(true);
      },
    },
  ];

  return (
    <>
      <div className="flex flex-col w-full">
        <div className="text-xs text-text-primary font-medium w-full border-b p-2">
          Resources
        </div>
        <div className="flex flex-col w-full p-2">
          {links.map((link) => (
            <Button
              key={link.title}
              variant="secondary"
              className="flex flex-row w-full gap-2 p-2 py-1 mb-1 justify-between cursor-pointer"
              onClick={() => {
                if (link.onClick) {
                  link.onClick();
                } else {
                  window.open(link.href, "_blank");
                }
              }}
            >
              <div className="flex flex-row gap-2 items-center">
                <link.icon className="size-3.5" />
                <span className="text-xs">{link.title}</span>
              </div>
              <ExternalLinkIcon
                className={link.onClick ? "hidden" : "size-3.5"}
              />
            </Button>
          ))}
        </div>
      </div>
      <KeyboardShortcutsModal
        isOpen={isShortcutsModalOpen}
        onClose={() => setIsShortcutsModalOpen(false)}
      />
    </>
  );
});

export default InfoPanel;
